/* eslint-disable no-bitwise */
/* eslint-disable prefer-template */
import CryptoJS from 'crypto-js';

const { REACT_APP_ENCRYPT_DECRYPT_KEY } = process.env;

export const generateHash = plainText => {
  const randomString = CryptoJS.lib.WordArray.random(16).toString();
  const usedIV = randomString.substr(0, 16);
  const key  = CryptoJS.enc.Latin1.parse(REACT_APP_ENCRYPT_DECRYPT_KEY);
  const iv   = CryptoJS.enc.Latin1.parse(usedIV);  
  const encrypted = CryptoJS.AES.encrypt(
    plainText,
    key,
    {iv,mode: CryptoJS.mode.CBC,padding: CryptoJS.pad.ZeroPadding
  });
  return `${encrypted}_${usedIV}`;
}

export const decryptHash = input => {
  let decryptedData = '';
  if(input.length > 0){
    const splitedInput = input.split('_');
    const data = splitedInput[0];
    const iv = splitedInput[1];
    const decodedData = CryptoJS.enc.Base64.parse(data);
    decryptedData = CryptoJS.AES.decrypt(
      {
        ciphertext: decodedData,
      },
      CryptoJS.enc.Utf8.parse(REACT_APP_ENCRYPT_DECRYPT_KEY),
      {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding,
      }
    );
    decryptedData = decryptedData.toString(CryptoJS.enc.Utf8).trim();
  }
    
    return decryptedData;
};
